export default () => ({
  flkty: null,
  mediaQuery: null,
  handleMediaChange: null,

  init() {
    this.mediaQuery = window.matchMedia('(max-width: 767px)');

    this.handleMediaChange = () => {
      this.handleBreakpoint();
    };

    this.handleBreakpoint();
    this.mediaQuery.addEventListener('change', this.handleMediaChange);
  },

  handleBreakpoint() {
    if (this.mediaQuery.matches) {
      this.initSlider();
    } else {
      this.destroySlider();
    }
  },

  initSlider() {
    if (this.flkty || !window.Flickity) return;

    this.flkty = new window.Flickity(this.$el, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      freeScroll: false,
      wrapAround: false,
    });
  },

  destroySlider() {
    if (!this.flkty) return;

    this.flkty.destroy();
    this.flkty = null;
  },

  destroy() {
    this.destroySlider();

    if (this.mediaQuery && this.handleMediaChange) {
      this.mediaQuery.removeEventListener('change', this.handleMediaChange);
    }
  },
});
